<hot-table [hotId]="instance" [settings]="settings" [licenseKey]="'non-commercial-and-evaluation'"></hot-table>
